module.exports = __webpack_public_path__ + "static/assets/c4146c5984305e300467b1f9c8eb137f.svg";